// import React from "react";
// import { Navigate } from "react-router-dom";

// const Authmiddleware = (props) => {
//   if (!localStorage.getItem("authUser")) {
//     return (
//       <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
//     );
//   }
//   return (<React.Fragment>
//     {props.children}
//   </React.Fragment>);
// };

// export default Authmiddleware;

import React, { useState, useEffect } from "react"
import { Navigate, useLocation } from "react-router-dom"

const Authmiddleware = ({ children }) => {
  const location = useLocation()

  // Token check function (jo api_helper mein bhi use hota hai)
  const isAuthenticated = () => {
    return !!localStorage.getItem("accessToken") // ya jo bhi tum token key use kar rahe ho
  }

  const [isAuth, setIsAuth] = useState(isAuthenticated())

  useEffect(() => {
    // Real-time check: token change hone pe re-evaluate
    const checkAuth = () => {
      setIsAuth(isAuthenticated())
    }

    // Storage event se detect (dusre tab se login/logout hone pe bhi kaam karega)
    window.addEventListener("storage", checkAuth)

    // Manual check bhi karo (login hone ke baad)
    checkAuth()

    // Optional polling (har 500ms check – agar storage event miss ho jaye)
    const interval = setInterval(checkAuth, 500)

    return () => {
      window.removeEventListener("storage", checkAuth)
      clearInterval(interval)
    }
  }, [])

  // Agar authenticated nahi hai to login pe bhej do + current location save kar lo
  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Authenticated hai to children (dashboard etc.) render karo
  return <React.Fragment>{children}</React.Fragment>
}

export default Authmiddleware
